<template>
  <vx-card no-shadow>
    <!-- Img Row -->

    <div v-if="horasExtras != {}" class="vx-col w-full mb-base">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label class="font-bold mb-4">Regime normal</label> <br />
          <!-- <label for="" class="text xs">Fazer o calculo com 50% ate as 20h</label> -->
          <div class="vx-col w-full mt-4">
            <vs-checkbox value="0.5>20" v-model="checkbox1"
              >Fazer o calculo com 50% ate as 20h</vs-checkbox
            >
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mt-5 mb-2">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span>Ou inserir a percentagem (%)</span>
              </div>
            </template>

            <vs-input v-model="percentagem" type="number" />
          </vx-input-group>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label class="font-bold mb-4">Regime Turnos</label> <br />
          <!-- <label for="" class="text xs">Fazer o calculo com 50% ate as 20h</label> -->
          <div class="vx-col w-full mt-4">
            <vs-checkbox v-model="checkbox2"
              >Calcular salario com 50% ate as 20h
            </vs-checkbox>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mt-5 mb-2">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span>Ou inserir a percentagem (%)</span>
              </div>
            </template>

            <vs-input v-model="percentagem2" type="number" />
          </vx-input-group>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label class="font-bold">Regime de turnos noturnos</label> <br />
          <label for="text-sm">Introduza a percentagem (%)</label>
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              type="number"
              icon-no-border
              v-model="noturno"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-else class="vx-col w-full mb-base">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label class="font-bold mb-4">Regime normal</label> <br />
          <!-- <label for="" class="text xs">Fazer o calculo com 50% ate as 20h</label> -->
          <div class="vx-col w-full mt-4">
            <vs-checkbox
              :disabled="horasExtras.daily_payment_percent_normal_shift != ''"
              value="0.5>20"
              v-model="checkbox10"
              >Fazer o calculo com 50% ate as 20h</vs-checkbox
            >
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mt-5 mb-2">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span>Ou inserir a percentagem (%)</span>
              </div>
            </template>

            <vs-input
              :disabled="checkbox10 == true"
              value="0.5>20"
              v-model="horasExtras.daily_payment_percent_normal_shift"
              type="number"
            />
          </vx-input-group>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label class="font-bold mb-4">Regime Turnos</label> <br />
          <!-- <label for="" class="text xs">Fazer o calculo com 50% ate as 20h</label> -->
          <div class="vx-col w-full mt-4">
            <vs-checkbox
              :disabled="horasExtras.daily_payment_percent_shift != ''"
              v-model="checkbox2"
              >Calcular salario com 50% ate as 20h
            </vs-checkbox>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full mt-5 mb-2">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <span>Ou inserir a percentagem (%)</span>
              </div>
            </template>

            <vs-input
              :disabled="checkbox2 == true"
              v-model="horasExtras.daily_payment_percent_shift"
              type="number"
            />
          </vx-input-group>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label class="font-bold">Regime de turnos noturnos</label> <br />
          <label for="text-sm">Introduza a percentagem (%)</label>
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              type="number"
              icon-no-border
              v-model="horasExtras.daily_payment_percent_night_shift"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="horasExtras == {}"
      class="flex flex-wrap items-center justify-end"
    >
      <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
      <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Repor</vs-button> -->
    </div>
    <div v-else class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="updateData">Actualizar</vs-button>
      <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Repor</vs-button> -->
    </div>
  </vx-card>
</template>

<script>
import http from "../../../../http-common";
import { PermissionsMixin } from "../../../mixins/permissions";
export default {
  mixins: [PermissionsMixin],
  data() {
    return {
      noturno: "",
      checkbox10: "",
      checkbox1: "",
      checkbox2: "",
      percentagem: "",
      percentagem2: "",
      contact: [
        {
          id: "",
          phone: "",
        },
      ],
      horasExtras: [{}],
      company: [],
      imagem: "",
      process: false,
      turnos: "",
      normal: "",
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.getData();
    },

    async saveData() {
      this.$vs.loading();
      setTimeout(() => {
        this.$vs.loading.close();
      }, 2000);
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        daily_payment_percent_night_shift: "30",
        daily_payment_percent_shift: "0.5<20",
        daily_payment_percent_normal_shift: "0.5<20",
      };

      await http
        .post("/companies/extra_hour_settings", data, config)
        .then((success) => {
          success;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Gravado com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          if (error.response.status == 422) {
            this.err = error.response.data;
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              title: "Erro",
              text: "Aconteceu algum erro",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }
        });
    },

    async updateData() {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      if (this.percentagem == "") {
        this.normal = this.checkbox1;
      } else {
        this.normal = this.percentagem;
      }

      if (this.percentagem2 == "") {
        this.turnos = this.checkbox1;
      } else {
        this.turnos = this.percentagem2;
      }
      const data = {
        daily_payment_percent_night_shift: this.noturno,
        daily_payment_percent_shift: this.turnos,
        daily_payment_percent_normal_shift: this.normal,
      };

      await http
        .put(
          `/companies/extra_hour_settings/${this.horasExtras.id}`,
          data,
          config
        )
        .then((success) => {
          success;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Gravado com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if (error.response.status == 422) {
            this.err = error.response.data;
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Erro",
              text: "Aconteceu algum erro",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }
        });
    },

    async getData() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      await http
        .get("/companies/extra_hour_settings", config)
        .then((success) => {
          this.horasExtras = success.data;
          if (this.horasExtras.daily_payment_percent_normal_shift == "0.5>20") {
            this.checkbox1 = "0.5>20";
          } else {
            this.percentagem =
              this.horasExtras.daily_payment_percent_normal_shift;
          }

          if (this.horasExtras.daily_payment_percent_shift == "0.5>20") {
            this.checkbox2 = "0.5>20";
          } else {
            this.percentagem2 = this.horasExtras.daily_payment_percent_shift;
          }
          this.noturno = this.horasExtras.daily_payment_percent_night_shift;
          success;
        })
        .catch((error) => {
          error;
          if (error.response.status == 422) {
            this.err = error.response.data;
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              title: "Erro",
              text: "Aconteceu algum erro",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }
        });
    },
  },
};
</script>
